import { AnimcoBannerType, AnimcoType } from '@app-types/animco';
import { PalpatineProduct } from '@app-types/api/palpatine';

import { filterValidItems } from '@helpers/content-editor';

import { JourneyType } from '@constants/journey';

export const getProductAnimco = (items: PalpatineProduct[], slug: string, isRenewal: boolean): AnimcoType => {
    const journeyType = isRenewal ? JourneyType.RENEWAL : JourneyType.ACQUISITION;
    const productAnimcoList = items.filter((datum) => datum.Slug === slug || datum.Slug === 'all-phones');

    const boxAnimcoList: AnimcoType['box'] = productAnimcoList
        .flatMap((datum) => datum.anim_animco_list.items)
        .filter((datum) => filterValidItems(journeyType, datum.parcours, datum.start_date, datum.end_date))
        .sort((a, b) => a.order - b.order)
        .map((animco) => ({
            type: animco.type,
            promoCode: animco?.promo_code,
            text: animco.text,
            tooltip: animco?.tooltip,
        }));

    const bannerAnimcoList: AnimcoBannerType[] = productAnimcoList
        .flatMap((datum) => datum.banner_animco_list.items)
        .filter((datum) => filterValidItems(journeyType, datum.parcours, datum.start_date, datum.end_date))
        .map((banner) => ({
            hasDisplaySticker: banner.display_sticker,
            stickerValue: banner.sticker_value,
            text: banner.text,
            stickerColor: banner.sticker_color,
            isInverted: !banner.inverted,
            tracking: banner.tracking,
        }));

    return { box: boxAnimcoList, banner: bannerAnimcoList };
};
